import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import {
  BRIEF_INFLUENCER_V2_DELIVERABLE_QUERY_KEY,
  BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY,
} from "../constants";
import { BriefService } from "../services/brief.service";

import { IDelPackage } from "@shared/lib/types";

export function useCreateBriefBulkDeliverables() {
  const {
    mutate: createBulk,
    isLoading: isCreatingBulk,
    data: deliverablesData,
    isSuccess: isCreatedBulk,
  } = useMutation({
    mutationFn: (data: { bulkDeliverables: IDelPackage[]; briefId: string }) =>
      BriefService.createBriefBulkDeliverables(data).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c, _, { briefId }) => {
      ToastService.success("Deliverable created successfully");

      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY],
      });
      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_DELIVERABLE_QUERY_KEY],
      });
      c.invalidateQueries({
        queryKey: [...BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY, "facets", briefId],
      });
    },
  });

  return {
    createBulk,
    isCreatingBulk,
    isCreatedBulk,
    deliverablesData,
  };
}
